<template>
	<div>
		<p class="ui-title">Enter new password</p>
		<ui-form
			:is-processing="isProcessing"
			:valid.sync="formValid"
			@submit="resetPassword"
		>
			<ui-input
				v-model="password"
				autocomplete="new-password"
				label="Password"
				minlength="8"
				required
				type="password"
			/>
			<ui-input
				v-model="verifyPassword"
				:error="passwordMatch"
				autocomplete="new-password"
				label="Verify password"
				required
				type="password"
			/>
			<div class="ui-layout ui-alignment-center-right">
				<ui-button
					:disabled="!formValid || isProcessing"
					primary
					raised
					text="Submit"
					type="submit"
				/>
			</div>
		</ui-form>
	</div>
</template>

<script>
import UiButton from "lib/components/ui/Button";
import UiForm from "lib/components/ui/Form";
import UiInput from "lib/components/ui/Input";
import http from "lib/modules/Http";
import alert from "lib/modules/Alert";

export default {
	name: "ResetPassword",
	components: {
		UiButton,
		UiForm,
		UiInput
	},
	props: {
		token: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			formValid: false,
			isProcessing: false,
			password: "",
			verifyPassword: ""
		};
	},
	computed: {
		passwordMatch() {
			if (this.password !== this.verifyPassword)
				return "Passwords do not match";

			return null;
		}
	},
	mounted() {
		this.$el.querySelector("input").focus();
	},
	methods: {
		resetPassword() {
			this.isProcessing = true;

			http.post("/api/v2/user/resetpassword", {
				token: this.token,
				password: this.password,
				conf_password: this.verifyPassword
			})
			.then(() => {
				this.$router.push({ name: "Login" });
			})
			.catch((error) => {
				alert.error("Reset password request failed", error.response);
			})
			.finally(() => {
				this.isProcessing = false;
			});
		}
	}
};
</script>
